import { render, staticRenderFns } from "./ProductModelsList.vue?vue&type=template&id=30f65dd1&scoped=true&"
import script from "./ProductModelsList.vue?vue&type=script&lang=js&"
export * from "./ProductModelsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f65dd1",
  null
  
)

export default component.exports